import { render } from "./RiFavorOn.vue?vue&type=template&id=c8eaa800"
import script from "./RiFavorOn.vue?vue&type=script&lang=js"
export * from "./RiFavorOn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiFavorOn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8eaa800"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8eaa800', __exports__)) {
    api.reload('c8eaa800', __exports__)
  }
  
  module.hot.accept("./RiFavorOn.vue?vue&type=template&id=c8eaa800", () => {
    api.rerender('c8eaa800', render)
  })

}


export default __exports__